export default [
    {
        key: "Situação",
        value: "",
        origemValue: ""
    },
];